import React from 'react'
import AccSessionTherapistsTable from './AccSessionTherapistsTable'

const Index = ({Session, setIsLoaded}) => {
    return (
        <>
        <AccSessionTherapistsTable Session = {Session} setIsLoaded={setIsLoaded}/>
        </>
    )
}

export default Index